// extracted by mini-css-extract-plugin
module.exports = {"outlinedSearchBox":"TemplateSearch_outlinedSearchBox__7pi7i","suggestedListItem":"TemplateSearch_suggestedListItem__HRMlq"};